import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface PageTransitionProps {
    children: ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{
                duration: 0.2,
                ease: [0.22, 1, 0.36, 1],
            }}
            style={{ flex: 1, width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}
        >
            {children}
        </motion.div>
    );
};

export default PageTransition;
